// Event start/end rules. Times are handled as UTC wall-clock time throughout
// the app (that is how events are displayed and stored - see
// EventDetailPage's `.utc()` formatting and the calendar's timeZone="UTC").

export const DEFAULT_EVENT_HOUR_UTC = 12;
export const DEFAULT_EVENT_LENGTH_MS = 2 * 60 * 60 * 1000;

// Start and end for a brand-new event: noon on the chosen day, two hours long.
// `selection` is what the calendar forwards ({timeStart, timeEnd}): clicking a
// day gives that day at 00:00, which means "this day", not midnight - so it
// becomes noon. A range with a real time of day (dragged on a timed grid) is
// kept as chosen. With no selection it is noon today.
export const defaultEventTimes = (selection, now = new Date()) => {
  const picked = selection && selection.timeStart;
  const hasTimeOfDay = picked && (picked.getUTCHours() !== 0 || picked.getUTCMinutes() !== 0);
  if (hasTimeOfDay) {
    return {
      timeStart: picked,
      timeEnd: selection.timeEnd || new Date(picked.getTime() + DEFAULT_EVENT_LENGTH_MS),
    };
  }
  const start = new Date(picked || now);
  start.setUTCHours(DEFAULT_EVENT_HOUR_UTC, 0, 0, 0);
  return { timeStart: start, timeEnd: new Date(start.getTime() + DEFAULT_EVENT_LENGTH_MS) };
};

// "YYYY-MM-DDTHH:mm[:ss]" (a datetime-local value, UTC wall-clock) -> ms, or NaN.
const parseLocal = (value) => Date.parse(`${value}Z`);

const formatLocal = (ms) => new Date(ms).toISOString().slice(0, -5);

// When the start time changes: if the end is now at or before the start,
// the end moves to two hours after it (returned as a datetime-local string).
// If the end is still after the start - or either value isn't a usable time -
// nothing should change, so this returns null.
export const endForNewStart = (startValue, endValue) => {
  const start = parseLocal(startValue);
  const end = parseLocal(endValue);
  if (Number.isNaN(start) || Number.isNaN(end)) return null;
  return end <= start ? formatLocal(start + DEFAULT_EVENT_LENGTH_MS) : null;
};
